import { logger } from '@inboundx/shared/platform';

import { supabase } from '@/lib/supabase';

// Injected by vite.config define from IX_API_KEY — the widget key every legacy client ships.
const SHARED_WIDGET_API_KEY = import.meta.env.VITE_IX_API_KEY?.trim();

/**
 * The client's own publishable widget key (IX-5066), or `null` for a legacy client,
 * which still uses the shared key. Authorized server-side by domain access.
 */
export async function fetchPublishableApiKey(domain: string): Promise<string | null> {
    const { data, error } = await supabase.rpc('get_publishable_api_key', {
        p_domain: domain,
    });
    if (error) throw error;
    return data ?? null;
}

/**
 * The key to send when chatting as `domain` from the backoffice: the client's own key
 * when it has one (the agent API refuses the shared key for those clients, from any
 * origin), otherwise the shared key. A failed lookup falls back to the shared key: that
 * is right for every legacy client, and a playground that cannot load at all is worse
 * than one refused for a single keyed client.
 */
export async function resolveWidgetApiKey(domain: string): Promise<string | undefined> {
    try {
        return (await fetchPublishableApiKey(domain)) ?? SHARED_WIDGET_API_KEY;
    } catch (error) {
        logger.error('Publishable API key lookup failed; falling back to the shared key', error);
        return SHARED_WIDGET_API_KEY;
    }
}
